import React from "react";
import {
  BsInstagram,
  BsTwitterX,
  BsFacebook,
  BsLinkedin,
  BsYoutube,
} from "react-icons/bs";

const Footer = () => {
  const divisions = {
    electronics: ["Solar Energy", "Electronic Inventions", "Electric Solutions"],
    software: ["Web Development", "Mobile Application", "ERP Systems"],
  };

  const socialLinks = [
    { icon: BsInstagram, url: "https://instagram.com/hexapi.tech", label: "Instagram" },
    { icon: BsFacebook, url: "https://www.facebook.com/HexaPiTech", label: "Facebook" },
    { icon: BsLinkedin, url: "https://www.linkedin.com/company/hexapi-tech/", label: "LinkedIn" },
    { icon: BsYoutube, url: "https://www.youtube.com/@hexapitech", label: "YouTube" },
    { icon: BsTwitterX, url: "https://x.com/HexaPiTech", label: "X (Twitter)" },
  ];

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-primary-600 to-primary-700 text-white pt-16 pb-8 relative overflow-hidden">
      {/* Hexagon Pattern Background */}
      <div className="absolute inset-0 hero-grid-pattern-dark opacity-50 pointer-events-none" />

      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        {/* Main Footer Content */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Logo & About */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="relative p-2 bg-white/90 rounded-xl shadow-lg">
                <img
                  src="/images/logo/logo.png"
                  alt="HexaPi Tech"
                  className="h-12"
                />
              </div>
              <span className="text-2xl font-bold text-white">
                HexaPi Tech
              </span>
            </div>
            <p className="text-primary-200 text-sm leading-relaxed">
              Innovative electronic and software solutions for businesses and
              individuals. Your trusted technology partner since 2020.
            </p>
          </div>

          {/* Electronics Division */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Electronics Division</h4>
            <ul className="space-y-2">
              {divisions.electronics.map((item, i) => (
                <li key={i}>
                  <a
                    href="#service"
                    className="text-primary-200 text-sm hover:text-white transition-colors"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Software Division */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Software Division</h4>
            <ul className="space-y-2">
              {divisions.software.map((item, i) => (
                <li key={i}>
                  <a
                    href="#service"
                    className="text-primary-200 text-sm hover:text-white transition-colors"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Reach Us</h4>
            <ul className="space-y-2 text-primary-200 text-sm">
              <li>
                <a
                  href="tel:+96103644705"
                  className="hover:text-white transition-colors"
                >
                  +961-03644705
                </a>
              </li>
              <li>
                <a
                  href="mailto:info@hexapi.tech"
                  className="hover:text-white transition-colors"
                >
                  info@hexapi.tech
                </a>
              </li>
              <li>1803, West Bekaa, Lebanon</li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            {/* Social Links */}
            <div className="flex gap-3">
              {socialLinks.map((social, i) => (
                <a
                  key={i}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className="w-10 h-10 bg-white/10 rounded-full flex items-center
                             justify-center hover:bg-white/20 transition-colors duration-300"
                >
                  <social.icon className="text-lg" />
                </a>
              ))}
            </div>

            {/* Copyright */}
            <p className="text-primary-100 text-xs">
              2020-{currentYear} © HexaPi Tech. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
